const RANKING_ITEMS = [
  {
    rank: 1,
    title: '《流浪地球3》',
    meta: '科幻 · 4K蓝光',
    hot: '本周播放 128万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '《海贼王》',
    meta: '动漫 · 高清',
    hot: '本周播放 115万',
    trend: 'up',
  },
  {
    rank: 3,
    title: '《繁花》',
    meta: '剧情 · 超清',
    hot: '本周播放 98万',
    trend: 'up',
  },
  {
    rank: 4,
    title: '《狂飙》',
    meta: '犯罪 · 4K',
    hot: '本周播放 87万',
    trend: 'down',
  },
  {
    rank: 5,
    title: '《庆余年 第二季》',
    meta: '古装 · 超清',
    hot: '本周播放 76万',
    trend: 'new',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">热度榜单</h2>
            <p className="mt-2 text-sm text-foreground-500">实时热门影视排行，看看大家都在看什么</p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="divide-y divide-background-200/60 bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
              {RANKING_ITEMS.map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-4 px-5 py-4 hover:bg-background-200/40 transition-colors cursor-pointer"
                >
                  <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center font-heading text-sm font-bold ${
                    item.rank === 1
                      ? 'bg-primary-500 text-foreground-950'
                      : item.rank === 2
                      ? 'bg-primary-300 text-foreground-900'
                      : item.rank === 3
                      ? 'bg-accent-300 text-foreground-900'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {item.rank}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                    <p className="text-xs text-foreground-400 mt-0.5">{item.meta}</p>
                  </div>
                  <div className="flex-shrink-0 text-right">
                    <p className="text-xs font-medium text-foreground-500">{item.hot}</p>
                    <div className="mt-0.5 flex justify-end">
                      {item.trend === 'up' && (
                        <span className="flex items-center gap-0.5 text-xs text-accent-600">
                          <i className="ri-arrow-up-line"></i>
                        </span>
                      )}
                      {item.trend === 'down' && (
                        <span className="flex items-center gap-0.5 text-xs text-secondary-600">
                          <i className="ri-arrow-down-line"></i>
                        </span>
                      )}
                      {item.trend === 'new' && (
                        <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700">
                          NEW
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}